import { Chip, ChipProps } from "@mui/material";
import { useEffect, useState } from "react";

interface SelectableChipProps extends ChipProps {
  defaultState?: boolean;
  value?: string | number;
  onSelected?: (value?: string | number) => void;
}

function SelectableChip({
  defaultState,
  value,
  onSelected,
  ...rest
}: SelectableChipProps) {
  const [selected, setSelected] = useState<boolean>(defaultState || false);

  const handleChipSelected = () => {
    const prev = selected;
    setSelected(!prev);
    if (onSelected && !selected) {
      onSelected(value);
    }
  };
  
  useEffect(() => setSelected(defaultState || false), [defaultState]);
  
  return (
    <Chip
      onClick={handleChipSelected}
      color={selected ? "primary" : "default"}
      sx={{
        bgcolor: selected ? "primary" : "white",
        m: 1,
        p: 1,
        border: 1,
        borderColor: selected ? "none" : "divider",
      }}
      {...rest}
    />
  );
}

export default SelectableChip;
